import React from 'react'
import './ElevatorMaintenance.scss'
import { connect } from 'react-redux'
import commonAction from '../../actions/common'
import { Picker, List, ImagePicker, Toast } from 'antd-mobile';
import { getFaultReasonInfoSimpleList, getPointTree, getSimpleList, getOrderLiftDetail, saveOrder, getOrderDetail, getUserSimpleList } from '@/api/ElevatorMaintenance';
import Drawer from '../../components/Drawer'
import Yes from '../../static/images/yes.png'
import Signature from '../../components/Signature'
import Lodding from '../../components/Lodding'
import { batchUploadFileByBase64, uploadFileByBase64, uploadFile, getWechatConfig, wxValidationPermissions } from '../../api/Sys'
import wx from 'weixin-js-sdk'
import { getLiftDetail } from '@/api/MyLiftDetail'
import transformFile from '@/libs/imageCompression'
import Select from '../../components/Select'
import VideoUploader from '../../components/VideoUploader'
import { buildTaskExecutedField, hasPendingAssignTask } from '../WorkOrderDetails/taskExecution'


function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

class F extends React.Component {
  render() {

    let dom = ""
    const obj = { ...this.props.item }

    if (obj.childrenList && obj.childrenList.length) {
      dom = obj.childrenList.map((item) => {
        return <Ff key={item.id} item={item} pointChooseIdList={this.props.pointChooseIdList} handlePointClink={this.props.handlePointClink} />
      })
    }
    return (
      <div className="treeitem">
        <div className={this.props.pointChooseIdList.indexOf(obj.id) >= 0 ? 'treeItemName treeItemNameActive' : 'treeItemName'} onClick={() => { this.props.handlePointClink(obj) }}>
          <span>{obj.name}</span>
          {this.props.pointChooseIdList.indexOf(obj.id) >= 0 ? <img src={Yes} alt="" /> : ''}
        </div>
        {dom}
      </div>
    )
  }
}

function Ff({ item, handlePointClink, pointChooseIdList }) {
  return (<div className="group">
    <F item={item} key={item.key} handlePointClink={handlePointClink} pointChooseIdList={pointChooseIdList} />
  </div>)
}

const data = [{
  url: 'https://zos.alipayobjects.com/rmsportal/PZUUCKTRIHWiZSY.jpeg',
  id: '2121',
},];
class ElevatorMaintenance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      files: data,
      remark: '', //备注信息,
      faultDescription: '', //故障描述
      solution: '', //解决方案
      replacementParts: '', //更换配件信息,
      scenePhoto: [], //现场图片
      orderPhoto: [], //工单图片,
      faultReasonInfoSimpleList: [], //故障类型
      pointList: [], //故障点
      openPoint: false, //故障点弹窗,
      openSignature1: false, //签名弹窗
      openSignature2: false, //签名弹窗
      openSignature3: false, //签名弹窗
      pointChooseIdList: [], //存储选中的故障点的key 传给子组建控制样式
      animating: false, //控制loding
      detail: {},
      liftDetail: {}, //电梯信息
      pointName: "", //选中的故障点名称
      status: '', //工单状态
      signatureImage: [], //签名
      accessories: [], // 配件list
      peoples: [], //维修人员
      accessoriesList: [], // 接口返回的数据
      peopleList: [], //接口返回的数据
      payStatus: [0],
      payStatusList: [
        {
          value: 0,
          label: '免费'
        },
        {
          value: 1,
          label: '收费'
        }
      ],
      videoFiles: [], // 视频文件列表
      videoTitle: '', // 视频标题
      videoStatus: 0, // 视频状态
      taskExecuted: false
    }
    this.pointList = [] //存放选中的故障点
    this.pointId = [] //存放选中的故障点的id
    this.pointChooseIdList = [] //存储选中的故障点的key
    this.liftId = '' //电梯id
    this.repairOrderId = ''
    this.postData = {} //数据
    this.pointName = []
    this.orderDetail = {} //工单详情
    this.liftCode = ''
    this.itemStyle = {
      'height': '60px',
    }
    this.canSearch = true
    this.currentPeople = null
  }
  componentDidMount() {
    const pathname = this.props.path;
    this.props.dispatch({ type: commonAction.setPathname, pathname })
    this.props.onRef(this);
    this.liftCode = this.props.match.params.id

    this.getLiftDetailFun(this.liftCode)
    // this.repairOrderId = this.props.location.query.repairOrderId
    this.getWechatConfigFun()
    this.getFaultReasonInfoSimpleListFun();
    this.getPointTreeFun();
  }

  // 判断是不是ios
  isIos = () => {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
  }
  // 为了获取repairOrderId
  getLiftDetailFun = async (liftCode) => {
    const res = await getLiftDetail({ liftCode });
    if (res.code === 200) {
      this.liftId = res.data.liftId
      this.getOrderLiftDetailFun()
      if (res.data.repairOrderId) {
        this.repairOrderId = res.data.repairOrderId

        this.getOrderDetailFun()
      }
    }
  }

  getSimpleListFun = async (v = '') => {
    this.canSearch = false
    const res = await getSimpleList({ keyword: v, size: 1000, });
    if (res.code === 200) {
      const accessoriesList = res.data.map(item => ({ ...item, materialId: item.id }))
      this.setState({
        accessoriesList
      })
    }
    this.canSearch = true
  }

  getUserSimpleListFun = async (v = '') => {
    this.canSearch = false
    const res = await getUserSimpleList({ keyword: v, size: 1000, });
    if (res.code === 200) {
      this.setState({
        peopleList: res.data
      })
    }
    this.canSearch = true
  }

  // 搜索项目
  handleSearch = (val, type) => {
    if (this.canSearch) {
      if (type === 'a') {
        this.getSimpleListFun(val)
      } else {
        this.getUserSimpleListFun(val)
      }
    }
  }
  // 下拉框聚焦
  handleFocus = (type) => {
    if (type === 'a') {
      this.getSimpleListFun()
    } else {
      this.getUserSimpleListFun()
    }
  }
  // 返回当前选中的值
  handleChoose = (v, item, type) => {
    let arr = []
    if (type === 'a') {
      arr = [...this.state.accessories]
      const index = arr.findIndex(i => i.gid === item.gid)
      arr[index].materialId = v.id
      arr[index].materialName = v.materialName
      arr[index].id = v.id
      this.setState({
        accessories: arr
      })
    } else {
      arr = [...this.state.peoples]
      const index = arr.findIndex(i => i.gid === item.gid)
      arr[index].teamworkUserId = v.userId
      arr[index].teamworkUserName = v.nickname
      arr[index].userId = v.userId
      arr[index].nickname = v.nickname
      this.setState({
        peoples: arr
      })
    }
  }

  addItem = (type) => {
    if (type === 'a') {
      const arr = [...this.state.accessories]
      const obj = {
        gid: guid(),
        materialId: null,
        materialName: null,
        useAmount: ''
      }
      arr.push(obj)
      this.setState({
        accessories: arr
      })
    } else {
      const arr = [...this.state.peoples]
      const obj = {
        gid: guid(),
        imageUrl: null,
        rate: null,
        teamworkUserId: null,
        teamworkUserName: null
      }
      arr.push(obj)
      this.setState({
        peoples: arr
      })
    }

  }

  moreInputChange = (gid, e) => {
    const arr = [...this.state.accessories]
    const index = arr.findIndex(item => item.gid === gid)
    arr[index].useAmount = e.target.value ? parseInt(e.target.value) : null
    this.setState({
      accessories: arr
    })
  }

  showSig = (item) => {
    this.currentPeople = { ...item }
    this.setState({
      openSignature3: true
    })
  }

  // 获取签名的base64 然后提交服务器
  getSignature3 = async (base64) => {
    this.setState({
      animating: true
    })
    const res1 = await this.submitBase64List()
    if (res1) {
      const res = await uploadFileByBase64(base64)
      if (res.code === 200) {
        // this.submitStatus = 4
        // this.signatureImageDataList.push({ imageUrl: res.data.url })
        // this.getLocation()
        const arr = [...this.state.peoples]
        const index = arr.findIndex(item => this.currentPeople.gid === item.gid)
        arr[index].imageUrl = res.data.url
        this.setState({
          peoples: arr,
          openSignature3: false
        })
      }
    }
    this.setState({
      animating: false
    })
  }

  deleteItem = (gid, type) => {
    let arr = []
    if (type === 'a') {
      arr = [...this.state.accessories]
    } else {
      arr = [...this.state.peoples]
    }
    const index = arr.findIndex(item => item.gid === gid)
    arr.splice(index, 1)
    if (type === 'a') {
      this.setState({
        accessories: arr
      })
    } else {
      this.setState({
        peoples: arr
      })
    }

  }

  // 获取故障原因
  getFaultReasonInfoSimpleListFun = async () => {
    const res = await getFaultReasonInfoSimpleList({ size: 1000 })
    if (res.code === 200) {
      const arr = res.data.map(item => {
        return {
          value: item.id,
          label: item.faultReason
        }
      })
      this.setState({
        faultReasonInfoSimpleList: arr
      })
    }
  }

  // 获取故障点
  getPointTreeFun = async () => {
    const res = await getPointTree({
      pageIndex: 1,
      pageSize: 1000,
    })
    if (res.code === 200) {
      this.setState({
        pointList: res.data
      })
    }
  }

  // 获取工单中电梯信息
  getOrderLiftDetailFun = async () => {
    const res = await getOrderLiftDetail({ liftId: this.liftId });
    console.log(res)
    if (res.code === 200) {
      const { videoTitle, videoStatus, videoParamList } = res.data;
      this.setState({
        liftDetail: res.data,
        videoTitle: videoTitle || '',
        videoStatus: videoStatus || 0,
        videoFiles: videoParamList && videoParamList.length ? videoParamList.filter(item => item.videoUrl).map(item => ({
          url: item.videoUrl,
          videoUrl: item.videoUrl,
          name: item.videoTitle
        })) : []
      })
    }
  }

  //获取工单详情
  getOrderDetailFun = async () => {
    const res = await getOrderDetail({ orderId: this.repairOrderId });
    if (res.code === 200) {
      this.orderDetail = res.data
      const orderDetail = res.data
      const { remark, replacementParts, solution, faultDescription, materialRecordList, orderTeamworkParamList, payStatus } = orderDetail
      let liveImageDataList = []
      orderDetail.liveImageDataList.forEach((item, index) => {
        liveImageDataList.push({
          id: index,
          url: item.imageUrl
        })
      })
      let orderImageDataList = []
      orderDetail.orderImageDataList.forEach((item, index) => {
        orderImageDataList.push({
          id: index,
          url: item.imageUrl
        })
      })
      let signatureImage = []
      if (orderDetail.signatureImageDataList && orderDetail.signatureImageDataList.length) {
        signatureImage = orderDetail.signatureImageDataList
      }
       // 初始化视频数据
      let videoFiles = []
      
      if (orderDetail.videoUrl && orderDetail.videoDataList.length) {
        videoFiles = orderDetail.videoDataList.map((item, index) => ({
          url: item.videoUrl,
          videoUrl: item.videoUrl,
          name: item.videoName
        }))
      }
      const accessories = materialRecordList.map(item => ({ ...item, gid: guid() }))
      const peoples = orderTeamworkParamList.map(item => ({ ...item, gid: guid(), userId: item.teamworkUserId, nickname: item.teamworkUserName }))
      this.setState({
        detail: orderDetail,
        value: [orderDetail.faultReasonId],
        remark,
        replacementParts,
        solution,
        faultDescription,
        scenePhoto: liveImageDataList,
        orderPhoto: orderImageDataList,
        status: orderDetail.status,
        pointChooseIdList: orderDetail.faultPointIdList,
        signatureImage,
        accessories,
        peoples,
        payStatus: [payStatus || 0],
        videoFiles,
        taskExecuted: false
      }, () => {
        this.getSimpleListFun();
        this.getUserSimpleListFun();
      })
      this.pointChooseIdList = orderDetail.faultPointIdList
      this.setFaultPoint(this.state.pointList)
    }
  }

  // 故障点回显时候用
  setFaultPoint = (list) => {
    list.forEach((item) => {
      this.getChooseFaultPoint(item);
    })
  }

  getChooseFaultPoint = (item) => {
    if (this.pointChooseIdList.indexOf(item.id)) {
      this.pointName.push(item.name)
      this.pointList.push(item)
      this.setState({
        pointName: String(this.pointName)
      })
      return
    }
    if (item.childrenList && item.childrenList.length) {
      this.setFaultPoint(item.childrenList)
    }
  }





  submit = () => {
    if (!this.repairOrderId) {
      Toast.info("暂无日志信息")
      return
    }
    this.props.history.push({ pathname: `/layout/log/${this.repairOrderId}` });
  }

  handleChange = (e) => {
    console.log(e)
  }



  // 备注信息
  handleRemarkChange = (event, type) => {
    this.setState({ [type]: event.target.value });
  }

  // 更换配件信息
  handleReplacementParts = (event) => {
    this.setState({ replacementParts: event.target.value });
  }

  handleTaskExecutedChange = (event) => {
    this.setState({
      taskExecuted: event.target.checked
    })
  }

  // 选择现场图片
  scenePhotoChange = (files, type, index) => {
    this.setState({
      scenePhoto: files
    })
  }

  // 选择工单图片
  orderPhotoChange = (files, type, index) => {
    this.setState({
      orderPhoto: files
    })
  }

  // 点击故障点打开弹窗
  handleClickfaultPointId = () => {
    if (this.state.status === 4) {
      return
    }
    this.setState({
      openPoint: true
    })
  }

  // 关闭故障点弹窗
  handleClosePoint = () => {
    this.setState({
      openPoint: false
    })
  }
  // 关签名弹窗
  handleCloseSignature = (v) => {
    console.log(v)
    this.setState({
      ['openSignature' + v]: false
    })
  }

  // 弹出签名弹窗
  clickSubmit = async () => {
    this.setState({
      openSignature1: true
    })

  }

  // 点击节点
  handlePointClink = (val) => {
    if (val.childrenList) {
      return
    }
    const haveKey = this.pointChooseIdList.indexOf(val.id);
    if (haveKey >= 0) {
      this.pointChooseIdList.splice(haveKey, 1);
      this.pointList.splice(haveKey, 1);
    } else {
      this.pointChooseIdList.push(val.id);
      this.pointList.push(val)
    }
    let pointName = []
    this.pointList.forEach((item) => {
      pointName.push(item.name)
    })
    this.setState({
      pointChooseIdList: this.pointChooseIdList,
      pointName: String(pointName)
    })
  }

  // 获取签名的base64 然后提交服务器
  getSignature2 = async (base64) => {
    this.setState({
      animating: true
    })
    const res1 = await this.submitBase64List()
    if (res1) {
      const res = await uploadFileByBase64(base64)
      if (res.code === 200) {
        this.submitStatus = 4
        this.signatureImageDataList.push({ imageUrl: res.data.url })
        this.getLocation()
        //调试专用
        // this.postData.lon = 120.298501
        // this.postData.lat = 30.41875
        // this.postData.address = '余杭区'
        // this.save()
      }
    }
  }

  // 获取签名的base64 然后提交服务器
  getSignature = async (base64) => {
    this.setState({
      animating: true
    })
    const res1 = await this.submitBase64List()
    if (res1) {
      const res = await uploadFileByBase64(base64)
      if (res.code === 200) {
        this.signatureImageDataList = [{ imageUrl: res.data.url }]
      }
      this.setState({
        openSignature2: true
      })
    }
    this.setState({
      animating: false
    })
  }

  // 签完字确定后保存数据
  save = async () => {
    this.postData.status = this.submitStatus
    this.postData.remark = this.state.remark
    this.postData.replacementParts = this.state.replacementParts
    this.postData.faultDescription = this.state.faultDescription
    this.postData.solution = this.state.solution
    this.postData.taskExecuted = buildTaskExecutedField(this.submitStatus, this.state.taskExecuted)
    this.postData.faultPointIdList = this.pointChooseIdList
    this.postData.faultReasonId = this.state.value ? this.state.value[0] : ''
    this.postData.liftId = this.state.liftDetail.liftId
    this.postData.templateId = this.state.liftDetail.templateId
    this.postData.signatureImageDataList = this.signatureImageDataList
    this.postData.materialUseParamList = this.state.accessories
    this.postData.orderTeamworkParamList = this.state.peoples
    this.postData.payStatus = this.state.payStatus[0];
    if (this.repairOrderId) {
      this.postData.id = this.repairOrderId
    }
    const res = await saveOrder(this.postData)
    if (res.code === 200) {
      this.setState({
        animating: false,
        open: false
      }, () => {
        this.props.history.goBack()
      })
    } else {
      this.setState({
        animating: false,
        open: false
      })
      Toast.fail("提交失败")
    }
  }

  // 获取授权
  getWechatConfigFun = async () => {
    let url = window.location.href
    if (this.isIos()) {
      url = localStorage.getItem('url')
    }
    const res = await getWechatConfig(url)
    if (res.code === 200) {
      const data = { ...res.data }
      data.jsApiList = ['getLocation']
      wxValidationPermissions(data)
    }
  }

  // 获取地理位置
  getLocation = () => {
    const that = this
    wx.getLocation({
      type: 'wgs84',
      success: (res) => {
        const BMap = window.BMap
        const ggPoint = new BMap.Point(res.longitude, res.latitude)
        var convertor = new BMap.Convertor();
        var pointArr = [];
        pointArr.push(ggPoint);
        const geoc = new BMap.Geocoder()
        convertor.translate(pointArr, 1, 5, (res) => {
          if (res.status === 0) {
            that.postData.lon = res.points[0].lng
            that.postData.lat = res.points[0].lat
            geoc.getLocation(res.points[0], function (rs) {
              if(rs) {
                that.setState({
                  address: rs.address
                })
                that.postData.address = rs.address
              }
              that.save()
            })
            // that.save()
          } else {
            that.save()
          }
        })
      },
      error: (error) => {
        that.save()
      }

    })
  }


  // 提交base64图片到服务器
  submitBase64List = async () => {
    // 验证视频上传 - 当videoStatus为20时表示强制上传
    if (this.state.videoStatus === 20 && this.state.videoTitle && !this.state.videoFiles.length) {
      Toast.fail('视频必须上传', 2)
      return false
    }
    
    // 检查videoParamList中是否有videoStatus=20的项但没有上传视频
    if (this.state.liftDetail.videoParamList && this.state.liftDetail.videoParamList.length) {
      for (let i = 0; i < this.state.liftDetail.videoParamList.length; i++) {
        const item = this.state.liftDetail.videoParamList[i];
        if (item.videoStatus === 20) {
          // 查找是否已上传该视频
          const uploadedVideo = this.state.videoFiles.find(file => file.name === item.videoTitle);
          if (!uploadedVideo) {
            Toast.fail(`${item.videoTitle}视频必须上传`, 2)
            return false;
          }
        }
      }
    }
    
    this.postData = { ...this.state.detail }
    let orderImageDataList = []
    let liveImageDataList = []
    let orderImageBase64ListFinish = []
    let liveImageBase64ListFinish = []
    if (this.state.orderPhoto && this.state.orderPhoto.length) {
      const orderImageBase64List = []

      for (let i = 0; i < this.state.orderPhoto.length; i++) {
        if (this.state.orderPhoto[i].file) {
          orderImageBase64List.push(await transformFile(this.state.orderPhoto[i]))
        } else {
          orderImageBase64ListFinish.push({
            imageType: 2,
            imageUrl: this.state.orderPhoto[i].url
          })
        }
      }


      // this.state.orderPhoto.forEach(item => {
      //   if (item.file) {
      //     orderImageBase64List.push(item.url)
      //   } else {
      //     orderImageBase64ListFinish.push({
      //       imageType: 2,
      //       imageUrl: item.url
      //     })
      //   }
      // })
      const orderImageDataListRes = await batchUploadFileByBase64({ base64List: orderImageBase64List })
      if (orderImageDataListRes.code === 200) {
        orderImageDataList = orderImageDataListRes.data.map(item => {
          const obj = {
            imageType: 2,
            imageUrl: item.url
          }
          return obj
        })
      }
    }
    if (this.state.scenePhoto && this.state.scenePhoto.length) {
      const liveImageBase64List = []

      for (let i = 0; i < this.state.scenePhoto.length; i++) {
        if (this.state.scenePhoto[i].file) {
          liveImageBase64List.push(await transformFile(this.state.scenePhoto[i]))
        } else {
          liveImageBase64ListFinish.push({
            imageType: 2,
            imageUrl: this.state.scenePhoto[i].url
          })
        }
      }

      // this.state.scenePhoto.forEach(item => {
      //   if (item.file) {
      //     liveImageBase64List.push(item.url)
      //   } else {
      //     liveImageBase64ListFinish.push({
      //       imageType: 1,
      //       imageUrl: item.url
      //     })
      //   }
      // })
      const liveImageDataListRes = await batchUploadFileByBase64({ base64List: liveImageBase64List })
      if (liveImageDataListRes.code === 200) {
        liveImageDataList = liveImageDataListRes.data.map(item => {
          const obj = {
            imageType: 1,
            imageUrl: item.url
          }
          return obj
        })
      }
    }
    this.postData.orderImageDataList = orderImageBase64ListFinish.concat(orderImageDataList)
    this.postData.liveImageDataList = liveImageBase64ListFinish.concat(liveImageDataList)
    
    // 处理视频文件
    let videoDataList = []
    let videoParamList = []
    
    // 如果有原始的videoParamList，先保留结构
    if (this.state.liftDetail.videoParamList && this.state.liftDetail.videoParamList.length) {
      videoParamList = this.state.liftDetail.videoParamList.map(item => {
        // 查找对应的已上传视频
        const uploadedVideo = this.state.videoFiles.find(file => file.name === item.videoTitle);
        return {
          videoTitle: item.videoTitle,
          videoUrl: uploadedVideo ? (uploadedVideo.videoUrl || uploadedVideo.url) : null,
          videoStatus: item.videoStatus // 直接使用原始videoStatus值
        };
      });
    }
    
    // 处理视频数据列表
    if (this.state.videoFiles && this.state.videoFiles.length) {
      try {
        for (let i = 0; i < this.state.videoFiles.length; i++) {
          const videoItem = this.state.videoFiles[i];
          
          // 添加视频信息到列表（视频已在选择时上传到服务器）
          videoDataList.push({
            videoType: 1,
            videoUrl: videoItem.videoUrl || videoItem.url,
            videoName: videoItem.name
          });
        }
      } catch (error) {
        console.error('视频处理错误:', error);
        Toast.fail('视频处理失败', 2);
      }
    }
    
    this.postData.videoDataList = videoDataList // 添加视频数据到提交数据中
    this.postData.videoParamList = videoParamList // 添加视频参数列表
    this.postData.videoStatus = this.state.videoStatus // 添加视频状态字段
    this.postData.videoTitle = this.state.videoTitle // 添加视频标题字段
    
    // 设置视频URL，如果有视频则使用第一个视频的URL
    if (videoDataList && videoDataList.length > 0) {
      this.postData.videoUrl = videoDataList[0].videoUrl;
    } else {
      this.postData.videoUrl = '';
    }
    
    return true
  }

  checkMAndP = () => {
    const m = this.state.accessories
    const p = this.state.peoples
    let result = true
    let a = false
    let b = false
    if (m && m.length) {
      a = m.some(item => !item.materialId || (!item.useAmount && item.useAmount !== 0))
      if (a) {
        Toast.info("请填写配件完整信息")
        return false
      }
    }
    if (p && p.length) {
      b = p.some(item => !item.teamworkUserId)
      if (b) {
        Toast.info("请填维修人完整信息")
        return false
      }
    }
    if (!a && !b) {
      result = true
    } else {
      result = false
    }
    return result
  }


  // 中途离开
  liveSubmit = async () => {
    const isCheck = this.checkMAndP()
    if (!isCheck) {
      // materialId useAmount
      // teamworkUserId
      return
    }
    this.setState({
      animating: true
    })
    this.submitStatus = 2
    if (await this.submitBase64List()) {
      this.getLocation()
      // this.postData.lon = 120.298501
      // this.postData.lat = 30.41875
      // this.postData.address = '余杭区'
      // this.save()
    }
  }







  render() {
    const { pointName, scenePhoto, signatureImage, orderPhoto, faultReasonInfoSimpleList, pointList, pointChooseIdList, liftDetail, status, accessories, peoples, accessoriesList, peopleList, payStatus, payStatusList, detail, taskExecuted } = this.state
    const map = pointList.map((item, index) => <Ff item={item} key={index} pointChooseIdList={pointChooseIdList} handlePointClink={this.handlePointClink} />)
    const showAssignTask = hasPendingAssignTask(detail)

    return (
      <div className="elevatorMaintenance">
        <div className="top">
          <ul>
            <li>
              项目名称<span>{liftDetail.projectName}</span>
            </li>
            <li>
              使用单位<span>{liftDetail.propertyUnitName}</span>
            </li>
            <li>
              使用证号<span>{liftDetail.useCertificateNumber}</span>
            </li>
            <li>
              电梯位置<span>{liftDetail.liftLocation}</span>
            </li>
			<li>
              客户等级<span>{liftDetail.grade}</span>
            </li>
            {
              showAssignTask ? (
                <li>
                  指派任务<span>{detail.assignTaskName}</span>
                </li>
              ) : ''
            }
          </ul>
        </div>
        <h1>维修记录</h1>
        <div className="information">
          <div className="pickerBox">
            <Picker data={payStatusList} cols={1} disabled={status === 4 ? true : false} className="forss" value={payStatus} onChange={v => this.setState({ payStatus: v })}>
              <List.Item arrow="horizontal">收费状态</List.Item>
            </Picker>
          </div>
          <div className="information-item information-item-point">
            <span>维修人员</span>
            <span>{liftDetail.currentUserName}</span>
          </div>
          <div className="information-item information-item-point" onClick={this.handleClickfaultPointId}>
            <span>故障点</span>
            <span className="faultPoint">{pointName ? pointName : ''}</span>
          </div>
          <div className="pickerBox">
            <Picker data={faultReasonInfoSimpleList} cols={1} disabled={status === 4 ? true : false} className="forss" value={this.state.value} onChange={v => this.setState({ value: v })}>
              <List.Item arrow="horizontal">故障原因</List.Item>
            </Picker>
          </div>
          <div className="textAreaBox">
            <h6>故障描述</h6>
            <textarea placeholder="无" disabled={status === 4 ? true : false} value={this.state.faultDescription} onChange={(e) => { this.handleRemarkChange(e, 'faultDescription') }} />
          </div>
          <div className="textAreaBox">
            <h6>解决方案</h6>
            <textarea placeholder="无" disabled={status === 4 ? true : false} value={this.state.solution} onChange={(e) => { this.handleRemarkChange(e, 'solution') }} />
          </div>
          <div className="textAreaBox">
            <h6>备注信息</h6>
            <textarea placeholder="无" disabled={status === 4 ? true : false} value={this.state.remark} onChange={(e) => { this.handleRemarkChange(e, 'remark') }} />
          </div>
          <div className="textAreaBox">
            <h6>更换配件信息</h6>
            <textarea placeholder="无" disabled={status === 4 ? true : false} value={this.state.replacementParts} onChange={(e) => { this.handleRemarkChange(e, 'replacementParts') }} />
          </div>
          <div className="textAreaBox moreAddBox">
            <h6 onClick={() => this.addItem('a')}>维修配件 +</h6>
            {
              accessories.map((item) => <div key={item.gid}>
                <Select label="materialName" handleChoose={(v) => this.handleChoose(v, item, 'a')} handleFocus={() => this.handleFocus('a')} valueKey="materialId" chooseData={item} search={(v) => this.handleSearch(v, 'a')} list={accessoriesList} />
                <input placeholder="数量" type="number" value={item.useAmount} onChange={(e) => this.moreInputChange(item.gid, e)} /><span onClick={() => this.deleteItem(item.gid, 'a')}>-</span>
              </div>)
            }
          </div>
          <div className="textAreaBox moreAddBox">
            <h6 onClick={() => this.addItem('p')}>维修人员 +</h6>
            {
              peoples.map((item) => <div key={item.gid}>
                <Select label="nickname" handleChoose={(v) => this.handleChoose(v, item, 'p')} handleFocus={() => this.handleFocus('p')} valueKey="userId" chooseData={item} search={(v) => this.handleSearch(v, 'p')} list={peopleList} />
                <a href="javascript:;" onClick={() => this.showSig(item)}>{item.imageUrl ? '已签名' : '签名'}</a>
                <span onClick={() => this.deleteItem(item.gid, 'p')}>-</span>
              </div>)
            }
          </div>

          {
            status === 4 && !scenePhoto.length ? "" : (
              <div className="fileUploadBox">
                <h6>现场照片</h6>
                <ImagePicker
                  className={status === 4 ? "displayClose" : ""}
                  files={scenePhoto}
                  onChange={this.scenePhotoChange}
                  selectable={scenePhoto.length < 5 && status !== 4}
                  multiple={true}
                  accept="image/gif,image/jpeg,image/jpg,image/png"
                />
              </div>
            )
          }
          {
            status === 4 && !orderPhoto.length ? "" : (
              <div className="fileUploadBox">
                <h6>工单照片</h6>
                <ImagePicker
                  className={status === 4 ? "displayClose" : ""}
                  files={orderPhoto}
                  onChange={this.orderPhotoChange}
                  selectable={orderPhoto.length < 5 && status !== 4}
                  multiple={true}
                  accept="image/gif,image/jpeg,image/jpg,image/png"
                />
              </div>)
          }
          {
            liftDetail.videoParamList && liftDetail.videoParamList.length ? 
              liftDetail.videoParamList.map((videoItem, index) => (
                <div className="fileUploadBox" key={index}>
                  <h6>{videoItem.videoTitle || '视频上传'}</h6>
                  <VideoUploader 
                    videoFiles={this.state.videoFiles.filter(file => file.name === videoItem.videoTitle)}
                    maxCount={1}
                    disabled={status === 4}
                    onUpload={uploadFile}
                    onChange={(videoData) => {
                      const newFiles = [...this.state.videoFiles];
                      const existingIndex = newFiles.findIndex(file => file.name === videoItem.videoTitle);
                      
                      if (videoData.videoFiles.length > 0) {
                        const newFile = {...videoData.videoFiles[0], name: videoItem.videoTitle};
                        
                        if (existingIndex >= 0) {
                          newFiles[existingIndex] = newFile;
                        } else {
                          newFiles.push(newFile);
                        }
                      } else if (existingIndex >= 0) {
                        newFiles.splice(existingIndex, 1);
                      }
                      
                      this.setState({ videoFiles: newFiles });
                    }}
                  />
                </div>
              ))
            : this.state.videoTitle ? (
              <div className="fileUploadBox">
                <h6>{this.state.videoTitle || '视频上传'}</h6>
                <VideoUploader 
                  videoFiles={this.state.videoFiles}
                  maxCount={1}
                  disabled={status === 4}
                  onUpload={uploadFile}
                  onChange={(videoData) => this.setState({ videoFiles: videoData.videoFiles })}
                  videoUrl={this.state.detail.videoUrl}
                />
              </div>
            ) : null
          }
          {
            signatureImage.map(item => {
              return (
                <div className="fileUploadBox" key={item.id}>
                  <h6>处理人</h6>
                  <img className="signatureImage" src={item.imageUrl} alt="" />
                </div>
              )
            })
          }
        </div>
        <Drawer direction="bottom" handleClose={this.handleClosePoint} open={this.state.openPoint}>
          <div className="faultPointIdBox">
            {map}
          </div>
        </Drawer>
        {
          status === 4 ? '' : (
            <div>
              {
                showAssignTask ? (
                  <label className="taskExecutedBox">
                    <input type="checkbox" checked={taskExecuted} onChange={this.handleTaskExecutedChange} />
                    <span>完成本次指派任务</span>
                  </label>
                ) : ''
              }
              <div className="footer" >
                <div onClick={this.liveSubmit}>中途离开</div>
                <div onClick={this.clickSubmit}>提交</div>
              </div>
              <Drawer direction="bottom" handleClose={() => { this.handleCloseSignature(1) }} open={this.state.openSignature1}>
                <Signature title="签名1" getSignature={this.getSignature} />
              </Drawer>
              <Drawer direction="bottom" handleClose={() => this.handleCloseSignature(2)} open={this.state.openSignature2}>
                <Signature title="签名2" getSignature={this.getSignature2} />
              </Drawer>
              <Lodding animating={this.state.animating} />
            </div>
          )
        }
        <Drawer direction="bottom" handleClose={() => { this.handleCloseSignature(3) }} open={this.state.openSignature3}>
          <Signature title="签名" getSignature={this.getSignature3} />
        </Drawer>
      </div>

    )
  }
}

export default connect()(ElevatorMaintenance);
